import { css } from "glamor";
import React from "react";
import { toBRLCurrency } from "../../utils/formatCurrency";
import { colors, spacing } from "../library";
import CourseCheckoutDetailItem from "./CourseCheckoutDetailItem";
import useCheckoutPricing from "../../hooks/useCheckoutPricing";

const titleClass = css({
  color: colors.greyShadow,
  fontWeight: 700,
  letterSpacing: 0.8,
  marginBottom: spacing.m,
});
const totalWrapper = css({
  flex: 1,
  display: "flex",
  justifyContent: "space-between",
  alignItems: "end",
  width: "100%",
  marginTop: "auto",
  paddingTop: spacing.l,
});
const totalLabel = css({
  fontSize: 24,
});
const totalNumber = css({
  fontSize: 24,
  color: colors.black,
  fontWeight: "bold",
});
const details = {
  flex: 1,
  display: "flex",
  flexDirection: "column",
};

export default function CourseCheckoutDetails(props) {
  const {
    offer,
    wasPreviousStudent,
    discountConfirmed,
    coupon,
    installmentCount,
    billingType,
  } = props;

  const {
    paymentValue,
    interestValue,
    pixDiscountValue,
    couponDiscountValue,
    studentDiscountValue,
    hasBonusCourses,
    hasStudentDiscount,
    hasInterest,
    isPixDiscountApplicable,
    isStudentDiscountActive,
    isCouponApplicable,
  } = useCheckoutPricing({
    offer,
    wasPreviousStudent,
    discountConfirmed,
    coupon,
    installmentCount,
    billingType,
  });

  const priceAfterStudentDiscount =
    offer?.price -
    (hasStudentDiscount && isStudentDiscountActive ? studentDiscountValue : 0);
  const priceAfterCouponDiscount =
    priceAfterStudentDiscount - (isCouponApplicable ? couponDiscountValue : 0);

  return (
    <div style={details}>
      <h3 className={titleClass}>Resumo da compra</h3>

      {offer?.type === "one_time" && (
        <CourseCheckoutDetailItem
          title={offer?.name}
          value={offer?.price}
          valueColor={colors.primary}
          titleColor={colors.primary}
          titleWeight="bold"
        />
      )}

      {hasBonusCourses && offer?.type === "one_time" && (
        <CourseCheckoutDetailItem
          title={offer?.meta?.course?.name}
          value={offer?.meta?.course?.price}
          striketrough
        />
      )}

      {offer?.meta?.bonusCourses?.map(({ name, price }, index) => (
        <CourseCheckoutDetailItem key={index} title={name} value={price} striketrough />
      ))}

      {isStudentDiscountActive && hasStudentDiscount && (
        <CourseCheckoutDetailItem
          title={
            <>
              Desconto de
              <b> {offer?.meta?.course?.resellDiscount}% para Aluno T2</b>
            </>
          }
          value={studentDiscountValue}
          valuePrefix="-"
          valueColor={colors.successDark}
        />
      )}

      {hasStudentDiscount &&
        isStudentDiscountActive &&
        (isCouponApplicable || isPixDiscountApplicable) && (
          <CourseCheckoutDetailItem
            title="Sub-total"
            value={priceAfterStudentDiscount}
            valueColor={colors.black}
            fontSize="18px !important"
          />
        )}

      {isCouponApplicable && (
        <CourseCheckoutDetailItem
          title="Desconto do Cupom"
          value={couponDiscountValue}
          valuePrefix="-"
          valueColor={colors.successDark}
        />
      )}

      {isCouponApplicable && isPixDiscountApplicable && (
        <CourseCheckoutDetailItem
          title="Sub-total"
          value={priceAfterCouponDiscount}
          valueColor={colors.black}
          fontSize="18px !important"
        />
      )}

      {isPixDiscountApplicable && (
        <CourseCheckoutDetailItem
          title={
            <>
              Desconto de <b>{offer?.pixDiscount}% para pagamentos via PIX</b>
            </>
          }
          value={pixDiscountValue}
          valuePrefix="-"
          valueColor={colors.successDark}
          backgroundColor={colors.successClear}
        />
      )}

      {hasInterest && (
        <CourseCheckoutDetailItem
          title="Juros do Parcelamento"
          value={interestValue}
          valuePrefix="+"
          valueColor={colors.dangerLight}
        />
      )}

      <div className={totalWrapper}>
        <p className={totalLabel}>Total</p>
        <p className={totalNumber}>
          {toBRLCurrency(paymentValue)}
          {offer?.type == "subscription" && " / mês"}
        </p>
      </div>
    </div>
  );
}
